import { render, staticRenderFns } from "./CustomerIdView.vue?vue&type=template&id=7cdba464&scoped=true"
import script from "./CustomerIdView.vue?vue&type=script&lang=js"
export * from "./CustomerIdView.vue?vue&type=script&lang=js"
import style0 from "./CustomerIdView.vue?vue&type=style&index=0&id=7cdba464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdba464",
  null
  
)

export default component.exports